<div class="text-center">
    <!-- <div class="selectMonth"><b>Select Type</b></div> -->
    <div class="relative">
        <ng-select #typeSelect class="custom-ng-select" [items]="typeList" bindLabel="type_selected" [multiple]="false"
            [closeOnSelect]="true" [clearable]="true" [loading]="typeLoading" [typeahead]="typeInput$"
            typeToSearchText="Employee Name" [virtualScroll]="true" [(ngModel)]="typeInit"
            [searchable]="false"></ng-select>
        <i class="fa fa-search" style="right: 17px !important;"></i>
    </div>
</div>